import axios from 'axios';
import {useQuery, useQueryClient, UseQueryResult} from 'react-query';
import {environment} from '../config/environment';

const fetchBlockTxs = (block_heigh: number) => {
    let query = [];
    query.push('height=' + block_heigh);
    return axios
        .get(`${environment.apiBase}/block/txs?${query.join('&')}`)
        .then((res) => res.data);
}


export const useBlockTxs = (block_height: number): UseQueryResult<any> => {
    const queryClient = useQueryClient();
    return useQuery(['blocktxs', block_height], () => fetchBlockTxs(block_height), {
        retry: false,
        staleTime: 1000 * 60 * 60,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            // Update tx
            data.payload && Object.keys(data.payload).forEach((i) => {
                const r = {type: 'txdetail', payload: data.payload[i]};
                queryClient.setQueryData(['txdetail', '0x' + data.payload[i].txid], r);
            });
        },
    });
};

export default useBlockTxs;
